"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSeo = void 0;
const collapsible_section_1 = __importDefault(require("../../ui/collapsible-section/collapsible-section"));
const initSeo = ($seo) => {
    const $collapsibleSection = $seo.querySelector('.collapsible-section');
    if ($collapsibleSection)
        new collapsible_section_1.default($collapsibleSection);
};
exports.initSeo = initSeo;
